import React, { createContext, useEffect, useState, useContext } from "react";
import { AuthContext } from "../auth/AuthContext";
import { httpGet } from "../lib/apiClients";
import { Environment } from "../utils/environments";
import { useNavigate } from "react-router-dom";

export const UserDataContext = createContext<any>(null);

export const UserDataProvider = ({ children }) => {
  const { currentUser } = useContext(AuthContext);
  const [userData, setUserData] = useState<any | null>(null);
  const [getCouponData, setCouponData] = useState<any | null>(null);
  const [memberData, setMemberData] = useState<any | null>(null);
  const [informationData, setInformationData] = useState<any | null>(null);
  const [businessHolidayData, setBusinessHolidayData] = useState<any | null>(
    null
  );
  const [interviewTicketData, setInterviewTicketData] = useState<any | null>(
    null
  );
  const [firstUserData, setFirstUserData] = useState<any | null>(null);
  const [supportTicketData, setSupportTicketData] = useState<any | null>(null);
  const navigate = useNavigate();
  useEffect(() => {
    if (!userData) {
      fetchUserData();
    }
  }, [currentUser, userData]);
  function hasFreeTicket(ticketList) {
    const freeTicket = ticketList.filter((ticket) => {
      return ticket.isFreeTicket == true;
    });
    if (freeTicket.length) {
      return freeTicket;
    } else {
      return false;
    }
  }
  async function fetchUserData() {
    setUserData(null);
    setInterviewTicketData(null);
    setSupportTicketData(null);
    setFirstUserData(null);
    if (!currentUser) {
      return;
    }
    try {
      const memberPromise = httpGet({
        pathName: "user-data",
        queryParams: { data: "MEMBER" },
      });
      const informationPromise = httpGet({
        pathName: "user-data",
        queryParams: { data: "INFORMATION" },
      });
      const bussinessHolidayPromise = httpGet({
        pathName: "user-data",
        queryParams: { data: "BUSSINESS_HOLIDAY" },
      });
      const memberCouponPromise = httpGet({
        pathName: "user-data",
        queryParams: { data: "MEMBER_COUPON" },
      });
      const memberInterviewTicketPromise = httpGet({
        pathName: "user-data",
        queryParams: { data: "MEMBER_INTERVIEW_TICKET" },
      });
      const memberSupportTicketPromise = httpGet({
        pathName: "user-data",
        queryParams: { data: "MEMBER_SUPPORT_TICKET" },
      });
      const memberD = await Promise.resolve(memberPromise);
      setMemberData({ ...memberD?.data });
      const informationD = await Promise.resolve(informationPromise);
      setInformationData({ ...informationD?.data });
      const businessHolidayD = await Promise.resolve(bussinessHolidayPromise);
      setBusinessHolidayData({ ...businessHolidayD?.data });
      const couponD = await Promise.resolve(memberCouponPromise);
      if (!getCouponData) {
        setCouponData(couponD?.data);
      }
      const interviewTicketD = await Promise.resolve(
        memberInterviewTicketPromise
      );
      const userHasFreeTicket = hasFreeTicket(
        interviewTicketD?.data.interviewtTicketList
      );
      var isFirstTimeUser = false;
      if (
        memberD?.data &&
        memberD?.data.useFreeInterviewTime == undefined &&
        userHasFreeTicket.length
      ) {
        isFirstTimeUser = true;
      }
      setFirstUserData({
        isFirstTimeUser: isFirstTimeUser,
        userHasFreeTicket: userHasFreeTicket,
      });
      setInterviewTicketData({
        ...interviewTicketD?.data,
        isFirstTimeUser: isFirstTimeUser,
        userHasFreeTicket: userHasFreeTicket,
      });
      const supportTicketD = await Promise.resolve(memberSupportTicketPromise);
      setSupportTicketData({ ...supportTicketD?.data });
      if (!getCouponData) {
        setCouponData(couponD?.data);
      }

      setUserData({
        ...memberD?.data,
        ...informationD?.data,
        ...businessHolidayD?.data,
        ...couponD?.data,
        ...interviewTicketD?.data,
        ...supportTicketD?.data,
        // isFirstTimeUser: isFirstTimeUser,
        // userHasFreeTicket: userHasFreeTicket,
      });
    } catch (error) {
      if (Environment.getBuildType() != "prod") {
        console.log(error);
      }
      navigate(`/error?code=${error.response?.status}`);
    }
  }
  async function fetchCoupon() {
    setCouponData(null);
    const memberCouponPromise = httpGet({
      pathName: "user-data",
      queryParams: { data: "MEMBER_COUPON" },
    });
    const coupon = await Promise.resolve(memberCouponPromise);
    setCouponData(coupon?.data);
  }
  var isTicketFree = true;
  const contextValue = {
    userData,
    setUserData,
    fetchUserData,
    getCouponData,
    setCouponData,
    memberData,
    informationData,
    businessHolidayData,
    interviewTicketData,
    supportTicketData,
    fetchCoupon,
    isTicketFree,
  };
  return (
    <UserDataContext.Provider value={contextValue}>
      {children}
    </UserDataContext.Provider>
  );
};
